// Weighbridge selector — shown after the first-time password login when no
// weighbridge is locked to this device. Tapping a card locks the device
// (localStorage) so subsequent logins use the scoped staff picker + PIN.

import { useWbWeighbridges } from '../hooks/useWbWeighbridges';
import { useKioskStore } from '../../../store/kioskStore';
import styles from './kiosk.module.css';

export function KioskWeighbridgeSelector() {
  const lockWeighbridge = useKioskStore((s) => s.lockWeighbridge);
  const { data, isLoading, isError } = useWbWeighbridges({ is_active: true });
  const weighbridges = data?.weighbridges ?? [];

  return (
    <div className={styles.centered}>
      <h2 className={styles.screenTitle}>Select this weighbridge</h2>
      <p className={styles.screenSubtitle}>
        This device will be locked to the weighbridge you choose.
      </p>
      {isLoading ? <p className={styles.muted}>Loading…</p> : null}
      {isError ? <div className={styles.error}>Could not load weighbridges.</div> : null}
      {!isLoading && !isError && weighbridges.length === 0 ? (
        <p className={styles.muted}>No active weighbridges configured.</p>
      ) : null}
      <div className={styles.cardGrid}>
        {weighbridges.map((wb) => (
          <button
            key={wb.enc_id}
            type="button"
            className={styles.pickCard}
            onClick={() => lockWeighbridge(wb.enc_id)}
            data-testid={`kiosk-wb-${wb.enc_id}`}
          >
            <span className={styles.cardName}>{wb.name}</span>
            <span className={styles.cardMeta}>
              <span
                className={`${styles.dot} ${wb.agent_online ? styles.dotOnline : styles.dotOffline}`}
              />
              {wb.agent_online ? 'Agent online' : 'No agent'}
            </span>
            <span className={styles.cardMeta}>{wb.yard?.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
